import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import { MyButton } from "../../../components/MyButton";

const styles = createUseStyles({
  ErrorFallback: {
    minHeight: "100vh",
    position: "relative",
  },
  content: {
    position: "absolute",
    top: "20%",
    left: "50%",
    transform: "translateX(-50%)",
    margin: "0 auto",
    width: "35rem",
    display: "grid",
    gap: "1rem",
    textAlign: "center",
    "& p": {
      margin: 0,
      width: "100%",
    },
  },
});
function ErrorFallback({ error, resetErrorBoundary }) {
  const errorLocal = typeof error === "string" ? { message: error } : error;
  const classes = styles();

  return (
    <div className={classes.ErrorFallback} role="alert">
      <div className={classes.content}>
        <p>Something went wrong:</p>
        <p>{errorLocal.message}</p>
        <MyButton onClick={resetErrorBoundary}>Try again</MyButton>
      </div>
    </div>
  );
}
ErrorFallback.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  resetErrorBoundary: PropTypes.func,
};
export default ErrorFallback;
